// import ButtonSlider from "./ButtonsSlider"

import EmployersSlider from "./EmployersSlider"
import SliderCustomArrows from "./SliderCustomArrows"

export default function Testimonials() {

	// function activeHandle(value) {
	//   setCurrSlide(value)
	// }

	return (
		<>
			<section id="testimonials">
				<div className="container mb-3 d-flex flex-row justify-content-between">
					<h2>What Customers Say About Salusion</h2>
					<SliderCustomArrows />

					{/* <div className="slider-button-wrapper">
            <div className="slider-switch-buttons">
              <ButtonSlider
                className="active"
                isActive={currSlide === "employers"}
                onClick={() => activeHandle("employers")}
              >
                Employers
              </ButtonSlider>
              
              <ButtonSlider
                className="active"
                isActive={currSlide === "workers"}
                onClick={() => activeHandle("workers")}
              >
                Workers
              </ButtonSlider>
            </div>

            <SliderCustomArrows />
          </div> */}
				</div>

				<div className="slider-wrapper"><EmployersSlider /></div>
			</section>
		</>
	)
}
